import styled from 'styled-components'
import { COLORS, SUCCESS_GREEN_COLOR } from 'consts/colors'
import { RADII, SHADOWS } from 'styles/consts'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(2px);
`

export const ModalContainer = styled.div`
  position: relative;
  background-color: ${COLORS.surface};
  border-radius: ${RADII.popup};
  width: 95%;
  max-width: 95%;
  max-height: 90vh;
  height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: ${SHADOWS.popup};
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid ${COLORS.border};
  flex-shrink: 0;
`

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${COLORS.textPrimary};
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const UploadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.primary};
  background-color: ${COLORS.primaryTint};
  border: 1px solid ${COLORS.border};
  border-radius: ${RADII.field};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: ${COLORS.fill};
    border-color: ${COLORS.borderHover};
  }

  &:active:not(:disabled) {
    background-color: ${COLORS.fillStrong};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const UploadMessage = styled.div<{ $isError?: boolean }>`
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10001;
  max-width: 600px;
  padding: 12px 20px;
  background-color: ${COLORS.surface};
  border: 1px solid ${COLORS.border};
  border-left: 4px solid
    ${props => (props.$isError ? COLORS.danger : SUCCESS_GREEN_COLOR)};
  border-radius: ${RADII.card};
  box-shadow: ${SHADOWS.menu};
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
`

export const UploadMessageText = styled.p<{ $isError?: boolean }>`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.textPrimary};
`

export const WarningsList = styled.ul`
  margin: 8px 0 0 0;
  padding-left: 20px;
  font-size: 12px;
  color: ${COLORS.textSecondary};
  list-style-type: disc;
`

export const WarningItem = styled.li`
  margin: 4px 0;
`

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: ${RADII.item};
  cursor: pointer;
  color: ${COLORS.textSecondary};
  font-size: 24px;
  line-height: 1;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${COLORS.fill};
    color: ${COLORS.textPrimary};
  }

  &:active {
    background-color: ${COLORS.fillStrong};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  }
`

export const ModalContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`
